import { useGetPartnerData } from 'legacy/lut/components/widgets/public/onboarding/onbPartnerForm/hooks/useGetPartnerData'
import { useGetPartnerFiles } from 'legacy/lut/components/widgets/public/onboarding/onbPartnerForm/hooks/useGetPartnerFiles'
import { useGetPartnerFlags } from 'legacy/lut/components/widgets/public/onboarding/onbPartnerForm/hooks/useGetPartnerFlags'
import { useEffect, useMemo, useState } from 'react'

import { RequestStatus } from 'clickNgo/configs/service/common'
import { Loader } from 'core-components/library/loader'

import { OnbFormDialogContent } from './components/onbFormDialogContent/OnbFormDialogContent'

interface IOnbFormDialogContentWrapperProps {
  partnerId: string
  appSource: string
}

export const OnbFormDialogContentWrapper = ({
  partnerId,
  appSource,
}: IOnbFormDialogContentWrapperProps) => {
  const [isForceUpdate, setIsForceUpdate] = useState(true)

  const { options, optionsForPartnerFlags } = useMemo(() => {
    return {
      options: { cacheKey: partnerId, isForce: isForceUpdate },
      optionsForPartnerFlags: {
        cacheKey: partnerId,
        isForce: isForceUpdate,
        paging: { pageSize: 1000, page: 0 },
      },
    }
  }, [isForceUpdate, partnerId])

  const { partnerData, status } = useGetPartnerData(partnerId)
  const { partnerFiles, status: partnerFilesStatus } = useGetPartnerFiles(partnerId, options)
  const { status: partnerFlagsStatus, ...partnerFlags } = useGetPartnerFlags(
    partnerId,
    optionsForPartnerFlags
  )

  useEffect(() => {
    if (partnerData) {
      setIsForceUpdate(false)
    }
  }, [partnerData])

  if (
    status === RequestStatus.PENDING ||
    partnerFilesStatus === RequestStatus.PENDING ||
    partnerFlagsStatus === RequestStatus.PENDING
  ) {
    return <Loader />
  }

  if (!partnerData) {
    return <p>Partner not found</p>
  }

  return (
    <OnbFormDialogContent
      partner={partnerData}
      partnerFlags={partnerFlags}
      partnerAttachments={partnerFiles}
      appSource={appSource}
    />
  )
}
